import _RecordVoiceOver from "@material-ui/icons/esm/RecordVoiceOver";
import _MicNone from "@material-ui/icons/esm/MicNone";
import _Send from "@material-ui/icons/esm/Send";
import _IconButton from "@material-ui/core/esm/IconButton";
import _AddCircleOutline from "@material-ui/icons/esm/AddCircleOutline";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { ReactMediaRecorder } from 'react-media-recorder';
import { useStyles } from "./FooterChatStyles";
import { detectInnerClick } from "../../../../helpers/detectClick";
import { useMessenger } from "../../../Messenger";
import { MessageInput } from "../MessageInput/MessageInput";
import { useChat } from "../../hooks/useChat";

const FooterChat = _ref => {
  let showMediaMenu = _ref.showMediaMenu,
      setShowMediaMenu = _ref.setShowMediaMenu,
      appliedColors = _ref.appliedColors,
      filesAvailable = _ref.filesAvailable,
      setFilesAvailable = _ref.setFilesAvailable;

  const _useChat = useChat(),
        handleSendMessage = _useChat.handleSendMessage;

  const _useMessenger = useMessenger(),
        config = _useMessenger.config.chat;

  const classes = useStyles(appliedColors);

  const _useState = useState(''),
        _useState2 = _slicedToArray(_useState, 2),
        message = _useState2[0],
        setMessage = _useState2[1];

  const refShowMediaButton = useRef(null);

  const handleSendVoiceMessage = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (blob) {
      const fileBlob = yield fetch(blob).then(r => r.blob());
      handleSendMessage({
        type: 'audio',
        content: {
          url: blob,
          file: fileBlob,
          id: 'temporal',
          name: 'voiceNote.wav',
          extension: 'wav'
        }
      });
    });

    return function handleSendVoiceMessage(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  detectInnerClick(refShowMediaButton, setShowMediaMenu, showMediaMenu);

  const handleCreateNewMessage = () => {
    let caption = false;

    if (filesAvailable.length > 0) {
      const visualMediaFiles = filesAvailable.filter(file => file.type !== 'file' && file.type !== 'audio');
      const audioFiles = filesAvailable.filter(file => file.type === 'audio');
      const fileFiles = filesAvailable.filter(file => file.type === 'file');
      caption = visualMediaFiles.length === filesAvailable.length || filesAvailable.length === 1;
      visualMediaFiles.length > 1 ? handleSendMessage({
        type: 'album',
        content: visualMediaFiles,
        caption: message.trim()
      }) : visualMediaFiles.length === 1 && handleSendMessage({
        type: visualMediaFiles[0].type,
        content: visualMediaFiles[0],
        caption: message.trim()
      });
      audioFiles.forEach(file => handleSendMessage({
        type: 'audio',
        content: file,
        caption: message.trim()
      }));
      fileFiles.forEach(file => handleSendMessage({
        type: 'file',
        content: file,
        caption: message.trim()
      }));
    }

    if (!caption && message.trim().length > 0) {
      handleSendMessage({
        type: 'text',
        content: message
      });
    }

    setFilesAvailable([]);
    setMessage('');
  };

  return _jsx("div", {
    className: classes.container
  }, void 0, Object.values(config.multimedia).some(option => option) && React.createElement(_IconButton, {
    component: "span",
    size: "small",
    ref: refShowMediaButton
  }, _jsx(_AddCircleOutline, {
    className: "".concat(classes.iconStyle, " ").concat(showMediaMenu ? classes.rotateRight : classes.rotateLeft)
  })), _jsx(MessageInput, {
    value: message,
    setValue: setMessage,
    handleSubmit: handleCreateNewMessage,
    inputId: 'chatInput'
  }), message.length > 0 || filesAvailable.length > 0 ? _jsx(_IconButton, {
    component: "span",
    size: "small",
    onClick: handleCreateNewMessage
  }, void 0, _jsx(_Send, {
    className: "".concat(classes.iconStyle, " send")
  })) : _jsx("div", {}, void 0, _jsx(ReactMediaRecorder, {
    audio: true,
    onStop: blob => handleSendVoiceMessage(blob),
    render: _ref3 => {
      let status = _ref3.status,
          startRecording = _ref3.startRecording,
          stopRecording = _ref3.stopRecording;
      return _jsx("div", {}, void 0, status !== 'recording' ? _jsx(_IconButton, {
        component: "span",
        size: "small",
        onClick: () => startRecording(),
        className: "".concat(status === 'recording' ? classes.hideIcon : '')
      }, void 0, _jsx(_MicNone, {
        className: "".concat(classes.iconStyle, " ").concat(classes.scaleIcon)
      })) : _jsx(_IconButton, {
        component: "span",
        size: "big",
        onClick: () => stopRecording()
      }, void 0, _jsx(_RecordVoiceOver, {
        className: "".concat(classes.iconStyle, " ").concat(classes.activeRecording, " ").concat(classes.scaleIcon)
      })));
    }
  })));
};

export { FooterChat };